export default __webpack_public_path__ + "static/media/sorted.eff61d1d.png";